import { render } from "./education-graph.vue?vue&type=template&id=f6bacf6e&lang=true"
import script from "./education-graph.vue?vue&type=script&lang=js"
export * from "./education-graph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__